module.exports = __webpack_public_path__ + "new-offer.svg?f147f566f8ad6e4cc8853fabc27f759a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-offer.svg
// module id = 298
// module chunks = 2